export const KNOWLEDGE_FORM_TYPES = [
  'LOGISTICS_SEND_OUT_TIME',
  'LOGISTICS_DELIVERED_IN_TIME',
  'LOGISTICS_SEND_OUT_PLACE',
  'LOGISTICS_SEND_PICTURES_BEFORE',
  'LOGISTICS_DELIVERY_COURIER_TYPE',
  'LOGISTICS_CONSOLIDATED_MULTIPLE_ORDER',
  'SHOP_FREE_SHIPPING',
  'SHOP_INVOICE',
  'SHOP_DROPSHIPPING',
  'SHOP_PICKUP_AT_HOME',
  'SHOP_CUSTOMER_SERVICE_WORKING_TIME',
  'ITEM_WARRANTY_SERVICE',
  'ITEM_EXPIRATION_DATE',
  'OTHER_PRIVATE_SHIPPING',
  'OTHER_GIFT',
  'SHOP_WHOLESALE',
] as const;
export interface KnowledgeFormParams {
  definition_code: Knowledge.KnowledgeType;
  knowledge_id?: string;
}

const LOGISTICS_KNOWLEDGE_FORM_TYPES = new Set<Knowledge.KnowledgeType>([
  'LOGISTICS_SEND_OUT_TIME',
  'LOGISTICS_DELIVERED_IN_TIME',
  'LOGISTICS_SEND_OUT_PLACE',
  'LOGISTICS_DELIVERY_COURIER_TYPE',
  'LOGISTICS_CONSOLIDATED_MULTIPLE_ORDER',
  'SHOP_FREE_SHIPPING',
]);

export function knowledgeFormNavigationSearch(params: KnowledgeFormParams) {
  const group = LOGISTICS_KNOWLEDGE_FORM_TYPES.has(params.definition_code) ? 'LOGISTICS' : 'STORE';
  return `?group=${group}&type=${encodeURIComponent(params.definition_code)}`;
}

export function knowledgeFormParser(edit: boolean) {
  return (raw: unknown): KnowledgeFormParams | undefined => {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return;
    const params = raw as Record<string, unknown>;
    if (!KNOWLEDGE_FORM_TYPES.includes(params.definition_code as any)) return;
    const fields = Object.keys(params).filter((key) => key !== 'definition_code');
    if ((!edit && fields.length) || (edit && !params.knowledge_id)) return;
    if (
      fields.some(
        (key) =>
          key !== 'knowledge_id' ||
          typeof params[key] !== 'string' ||
          !(params[key] as string).trim() ||
          (params[key] as string).length > 512,
      )
    )
      return;
    return raw as KnowledgeFormParams;
  };
}
